import {computeAreaPoint, computePoints, constructPolygonsWith2Areas} from "./UtilityFunctions";

function computeVoltaUnsymmetricalShed (instalationInfo, totalModules) {
    /*
                        60m / 51m
      p1---------------------------------------p4
      |  pn1------------------------------pn4  |
      |  |                                 |   |
      |  pn2------------------------------pn3  |
      p6---------------------------------------p5  26m
      |  ps1------------------------------ps4  |
      |  |                                 |   |
      |  |                                 |   |
      |  |                                 |   |
      |  |                                 |   |
      |  ps2------------------------------ps3  |
      p2---------------------------------------p3

    */

    // google variable api
    const google = window.google;

    const margeBetweenModules = instalationInfo.margeBetweenModules; // ex: 0.02m
    const inclination = instalationInfo.inclinaison; // ex: 17°
    const margeBetweenSide = 0.1;
    const margeMiddleRidge = 0.5;

    const p1 = new google.maps.LatLng(instalationInfo.coordinates[0]);
    const p2 = new google.maps.LatLng(instalationInfo.coordinates[1]);
    const p3 = new google.maps.LatLng(instalationInfo.coordinates[2]);
    const p4 = new google.maps.LatLng(instalationInfo.coordinates[3]);

    // compute 4 different orientations
    const orientation12 = google.maps.geometry.spherical.computeHeading(p1, p2);
    const orientation21 = google.maps.geometry.spherical.computeHeading(p2, p1);
    const orientation23 = google.maps.geometry.spherical.computeHeading(p2, p3);
    const orientation32 = google.maps.geometry.spherical.computeHeading(p3, p2);

    const totalWidth = google.maps.geometry.spherical.computeDistanceBetween(p1, p2);

    const panNordWidth = 3;
    const panSudWidth = totalWidth - panNordWidth;

    // compute the middle point (p5 is not necessary because we don't need to compute pn3 or ps4)
    const p6 = new google.maps.LatLng(google.maps.geometry.spherical.computeOffset(p1, panNordWidth, orientation12));

    // compute the first solar panel area (little one)
    let ps1 = computeAreaPoint(p6, margeMiddleRidge, 0, orientation12, orientation23);
    let ps2 = computeAreaPoint(p2, margeBetweenSide, margeBetweenSide, orientation21, orientation23);
    let ps3 = computeAreaPoint(p3, margeBetweenSide, margeBetweenSide, orientation12, orientation32);

    // size of the little one (north for reference)
    const sizeOfAreaSouth = {
        width: google.maps.geometry.spherical.computeDistanceBetween(ps1, ps2),
        length: google.maps.geometry.spherical.computeDistanceBetween(ps2, ps3)
    };

    // size of one module
    const sizeOfModule = {
        length: instalationInfo.height + margeBetweenModules,
        width: instalationInfo.width + margeBetweenModules
    };

    const maxCol = Math.floor(sizeOfAreaSouth.length / sizeOfModule.length);
    const maxRow = Math.floor((sizeOfAreaSouth.width / Math.cos(inclination * Math.PI / 180)) / sizeOfModule.width);

    let bestDiff = totalModules;
    let bestConfig = {col: 0, row: 0};

    for (let col = 1; col <= maxCol; col++) {
        for (let row = 1; row <= maxRow; row++) {
            const modulesCount = col * row;
            const diff = Math.abs(totalModules - modulesCount);
            if (diff < bestDiff) {
                bestDiff = diff;
                bestConfig = {col, row};
            }
        }
    }

    // compute the new size for the South area
    const newSizeOfAreaSouth = {
        width: bestConfig.row * (sizeOfModule.width * Math.cos(inclination * Math.PI / 180)),
        length: bestConfig.col * sizeOfModule.length
    };

    // adjust the size of the module to fit the new area
    const adjustedSizeOfModule = {
        length: newSizeOfAreaSouth.length / bestConfig.col,
        width: newSizeOfAreaSouth.width / bestConfig.row
    };

    // compute the new starting point (south)
    ps1 = computeAreaPoint(
        ps1,
        (sizeOfAreaSouth.width - newSizeOfAreaSouth.width) / 2,
        (sizeOfAreaSouth.length - newSizeOfAreaSouth.length) / 2,
        orientation12,
        orientation23
    );

    // compute the coords of all the panels in the south area
    return constructPolygonsWith2Areas(computePoints(bestConfig, adjustedSizeOfModule, ps1, {
        first: orientation23,
        second: orientation12
    }));
}

export default computeVoltaUnsymmetricalShed;